import SvgIcon from './svg-icon.svelte';
import * as SvgIconTypes from './types';
import { icons } from './constants';

const IconName = icons;

export { SvgIcon, SvgIconTypes, IconName };
